var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgEyee = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M84.922 48.5S68.375 66 47.96 66C27.547 66 11 48.5 11 48.5S27.547 31 47.96 31c20.414 0 36.962 17.5 36.962 17.5Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M47.961 65.24c9.395 0 17.011-7.495 17.011-16.74 0-9.245-7.616-16.739-17.01-16.739-9.396 0-17.012 7.494-17.012 16.74 0 9.244 7.616 16.738 17.011 16.738Z"
  }), React.createElement("path", {
    fill: color,
    d: "M47.96 57.63c5.125 0 9.28-4.087 9.28-9.13 0-5.042-4.155-9.13-9.28-9.13-5.124 0-9.278 4.088-9.278 9.13 0 5.043 4.154 9.13 9.279 9.13Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M53.837 57.022c2.392 0 4.33-1.908 4.33-4.26 0-2.354-1.938-4.262-4.33-4.262-2.391 0-4.33 1.908-4.33 4.261s1.939 4.261 4.33 4.261Z"
  }));
};
export default SvgEyee;